import React from 'react';

import {
    SIconContainer,
    SItemDescription,
    SItem,
} from './styles';

const IconItem = ({
    Icon,
    description
}) => {
    return (
        <SItem>
            <SIconContainer>
                <Icon className="svg-icon" />
            </SIconContainer>
            <SItemDescription
                dangerouslySetInnerHTML={{ __html: description }}
            />
        </SItem>
    );
};

export default IconItem;
